import "../../../Forms/ResultSchedule/ResultScheduleComponent";
import "../Info/GuardCompanies/SiteConfigurationGroupGuardCompaniesInfoComponent";
import "../Info/Instructions/SiteConfigurationGroupInstructionsInfoComponent";
import "../Info/Schedule/SiteConfigurationGroupScheduleInfoComponent";
import "../Info/ScheduleException/SiteConfigurationGroupScheduleExceptionInfoComponent";

import "./Edit/ConfigurationGroupDetectionEditComponent";
import "./SiteConfigurationGroupDetection.html";
import "./SiteConfigurationGroupDetection.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import SiteConfigurationGroupDetectionComponentController from "./SiteConfigurationGroupDetectionComponentController";

export class SiteConfigurationGroupDetectionComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            configurationGroup: "<",
            deleted: "&",
            site: "<",
        };
        this.controller = SiteConfigurationGroupDetectionComponentController;
        this.templateUrl = "/App/Components/Site/ConfigurationGroups/Detection/SiteConfigurationGroupDetection.html";
    }
}

module("mmManagePortal").component("mmSiteConfigurationGroupDetection", new SiteConfigurationGroupDetectionComponent());
